import Swal from "sweetalert2";

let messageErrorDefault = "Não conseguimos processar o pedido, tente novamente mais tarde!";
let messageWarningDefault = "Ufaaa! Não apagamos nada.";
let timerDefault = 5000;
let messageSuccess = 'Gravado com sucesso!';

/**
 *
 * @param message {string}
 * @param type {SweetAlertType}
 * @param position {string}
 * @param timer {number} 5000
 * @return Promise<SweetAlertResult>
 */
export const swallCustom = (message, type, position, timer = timerDefault) => {
    return Swal.fire({
        position: position,
        type: type,
        title: message,
        showConfirmButton: true,
        timer: timer
    })
};

/**
 *
 * @param message {String}
 * @param type {SweetAlertType} info
 * @param position {String} 'top' | 'top-start' | 'top-end' | 'top-left' | 'top-right' | 'center' | 'center-start' | 'center-end' | 'center-left' | 'center-right' | 'bottom' | 'bottom-start' | 'bottom-end' | 'bottom-left' | 'bottom-right'
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
export const toastMessage = (message, type = "info", position = "top-end", timer = timerDefault) => {
    const swallMessage = Swal.mixin({
        toast: true,
        position: position,
        showConfirmButton: true,
        timer: timer,
    });

    return swallMessage.fire({
        type: type,
        title: message
    });
};

/**
 *
 * @param message {String} Gravado com sucesso!
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
export const toastSuccess = (message = messageSuccess, timer = timerDefault) => {
    return toastMessage(message, "success", "top-end", timer);
};

/**
 *
 * @param message {String} Não conseguimos processar o pedido, tente novamente mais tarde!
 * @param timer {number} 5000
 * @return {Promise<SweetAlertResult>}
 */
export const toastError = (message = messageErrorDefault, timer = timerDefault) => {
    return toastMessage(message, "error", "top-end", timer);
};

/**
 *
 * @param message {String} Ufaaa! Não apagamos nada.
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
export const toastWarning = (message = messageWarningDefault, timer = timerDefault) => {
    return toastMessage(message, "warning", "top-end", timer);
};

/**
 *
 * @param message {String} Não conseguimos processar o pedido, tente novamente mais tarde!
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
export const alertErrorDatatable = (message = messageErrorDefault, timer = timerDefault) => {
    return toastError(message, timer);
};

/**
 *
 * @param message {String} Ufaaa! Não apagamos nada.
 * @param position {String} top-end
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
export const toastInfo = (message = messageWarningDefault, position = "top-end", timer = timerDefault) => {
    return toastMessage(message, "info", position, timer);
};

/**
 *
 * @param message {String}
 * @param type {SweetAlertType}
 * @param position {String}
 * @param timer {Number} 5000
 */
window.swallCustom = (message, type, position, timer = timerDefault) => {
    return swallCustom(message, type, position, timer)
};

/**
 *
 * @param message {String} Ufaaa! Não apagamos nada.
 * @param position {String} top-end
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
window.toastInfo = (message = messageWarningDefault, position = "top-end", timer = timerDefault) => {
    return toastInfo(message, position, timer)
};

/**
 *
 * @param message {String}
 * @param type {SweetAlertType} info
 * @param position {String} 'top' | 'top-start' | 'top-end' | 'top-left' | 'top-right' | 'center' | 'center-start' | 'center-end' | 'center-left' | 'center-right' | 'bottom' | 'bottom-start' | 'bottom-end' | 'bottom-left' | 'bottom-right'
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
window.toastMessage = (message, type = "info", position = "top-end", timer = timerDefault) => {
    return toastMessage(message, type, position, timer)
};

/**
 *
 * @param message {String} Gravado com sucesso!
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
window.toastSuccess = (message = messageSuccess, timer = timerDefault) => {
    return toastSuccess(message, timer)
};

/**
 *
 * @param message {String} Não conseguimos processar o pedido, tente novamente mais tarde!
 * @param timer {number} 5000
 * @return {Promise<SweetAlertResult>}
 */
window.toastError = (message = messageErrorDefault, timer = timerDefault) => {
    return toastError(message, timer)
};

/**
 *
 * @param message {String} Ufaaa! Não apagamos nada.
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
window.toastWarning = (message = messageWarningDefault, timer = timerDefault) => {
    return toastWarning(message, timer)
};

/**
 *
 * @param message {String} Não conseguimos processar o pedido, tente novamente mais tarde!
 * @param timer {Number} 5000
 * @return {Promise<SweetAlertResult>}
 */
window.alertErrorDatatable = (message = messageErrorDefault, timer = timerDefault) => {
    return alertErrorDatatable(message, timer)
};

window.Swal = Swal;

export { Swal };